<div class="design-huddle-product-creator">
  <div *ngIf="!showEditor" class="creator-setup">
    <div class="creator-header">
      <h2>Create Product with Design Huddle</h2>
      <p>Choose a template to start designing your product</p>
    </div>

    <div class="creator-content">
      <div class="template-selection" *ngIf="!selectedTemplate">
        <button
          mat-raised-button
          color="primary"
          (click)="openTemplateSelector()"
          class="select-template-btn">
          <mat-icon>palette</mat-icon>
          Select Design Template
        </button>
      </div>

      <div class="selected-template" *ngIf="selectedTemplate">
        <div class="template-preview">
          <img [src]="selectedTemplate.thumbnailUrl" [alt]="selectedTemplate.name">
        </div>
        <div class="template-details">
          <h3>{{ selectedTemplate.name }}</h3>
          <p class="category">{{ selectedTemplate.category }}</p>
          <p class="description" *ngIf="selectedTemplate.description">
            {{ selectedTemplate.description }}
          </p>
          <button mat-button (click)="openTemplateSelector()">
            Change Template
          </button>
        </div>
      </div>
    </div>

    <div class="creator-footer">
      <button mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>

  <div *ngIf="showEditor" class="creator-editor">
    <app-design-huddle-editor
      [projectId]="projectId"
      [editorUrl]="editorUrl"
      [autoSave]="true"
      [showSaveButton]="true"
      (onSave)="onEditorSave($event)"
      (onPublish)="onEditorPublish($event)"
      (onClose)="onEditorClose()"
      (onError)="onEditorError($event)">
    </app-design-huddle-editor>
  </div>
</div>
